__turbopack_context__.v({
  "Button": "Rd951a_Button",
  "ButtonContainer": "Rd951a_ButtonContainer",
  "Content": "Rd951a_Content",
  "Expanded": "Rd951a_Expanded",
  "Inner": "Rd951a_Inner",
  "RichText": "Rd951a_RichText",
  "Root": "Rd951a_Root",
  "T1HerotitleBold": "Rd951a_T1HerotitleBold",
  "T1HerotitleRegular": "Rd951a_T1HerotitleRegular",
  "T2ModuletitleBold": "Rd951a_T2ModuletitleBold",
  "T2ModuletitleRegular": "Rd951a_T2ModuletitleRegular",
  "T3SectiontitleBold": "Rd951a_T3SectiontitleBold",
  "T3SectiontitleRegular": "Rd951a_T3SectiontitleRegular",
  "T4Focustitle": "Rd951a_T4Focustitle",
  "T5Cardtitle": "Rd951a_T5Cardtitle",
  "T6Richcardtitle": "Rd951a_T6Richcardtitle",
  "T7Subtitle": "Rd951a_T7Subtitle",
  "T8Microtitle": "Rd951a_T8Microtitle",
  "Text": "Rd951a_Text",
  "Title": "Rd951a_Title",
});
